import { readCheckedValue } from '../../field-viewer/prehydration-readers';
import { acceptOnlyValidOptionByValue } from '../../field-viewer/shared-normalizers';
export const eventsRsvpViewer = {
    normalizeLoadedValue: acceptOnlyValidOptionByValue,
    readPrehydrationValue: readCheckedValue
};

//# sourceMappingURL=definition-viewer.js.map